import { removeNulls, safeParseNullDefault } from 'shouldve-been-js';

class CurrentUser {

    private _userId: string;
    private _username: string;
    private _email: string;
    private _access: string[];

    public constructor(userId: string, username: string, email: string, access: string[]) {

        this._userId = userId;
        this._username = username;
        this._email = email;
        this._access = access;
    }

    public get userId(): string {
        return this._userId;
    }

    public set userId(value: string) {
        this._userId = value;
    }

    public get username(): string {
        return this._username;
    }

    public set username(value: string) {
        this._username = value;
    }

    public get email(): string {
        return this._email;
    }

    public set email(value: string) {
        this._email = value;
    }

    public get access(): string[] {
        return this._access;
    }

    public set access(value: string[]) {
        this._access = value;
    }

    public copy(): CurrentUser {
        return new CurrentUser(this.userId, this.username, this.email, [...this.access]);
    }

    public hasAccess(accessType: string): boolean {
        return this.access.includes(accessType);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): CurrentUser | null {

        const userId: string | null = safeParseNullDefault<string>(json?.userId, '');
        const username: string | null = safeParseNullDefault<string>(json?.userName, '');
        const email: string | null = safeParseNullDefault<string>(json?.email, '');
        
        if (userId === null || username === null || email === null || userId === '' || username === '' || !Array.isArray(json?.permissions)) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call
        const access: (string | null)[] = json?.permissions.map((permission: any) => safeParseNullDefault<string>(permission, ''));

        return new CurrentUser(userId, username, email, removeNulls(access));
    }
}

export default CurrentUser;